import dayjs from "dayjs";
import { parse } from "querystring";
import { USER_PRODUCT_STATUS } from "src/constants/product";
import i18n from "src/i18n";

export default {};

export const getCurrency = (country: string): string => {
  return /(ko|kr)/gi.test((country || "").toLocaleLowerCase()) ? "₩ " : "$ ";
};

export const getURLInQueryString = (qs: string, key: string): string => {
  if (qs) {
    const urls = qs.split(`${key}=`);
    if (urls.length > 1) {
      return urls[1];
    }
  }
  return "";
};

export const getParseQueryString = (
  search: string,
): Record<string, string | string[] | number> => {
  const qs = search.replace(/^[?]/gi, "");
  return parse(qs);
};

export const getUrlToHistory = (
  url: string,
): [string, Record<string, string>] => {
  const urls = url.split("?");
  return [urls[0], parse(urls[1]) as Record<string, string>];
};

export const isKorean = (): boolean => {
  return i18n.languages[0] === "ko";
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createScripts = (scripts: string[]): Promise<any[]> => {
  return Promise.all(
    scripts.map(async (url) => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = url;
        script.async = true;
        document.body.appendChild(script);
        script.onload = () => {
          resolve(true);
        };
      });
    }),
  );
};

// 정기구독 여부
export const isSubscription = (status: string): boolean => {
  return (
    [
      USER_PRODUCT_STATUS.SUB_CREATED,
      USER_PRODUCT_STATUS.SUB_ACTIVATED,
      USER_PRODUCT_STATUS.SUB_DEACTIVATED,
      USER_PRODUCT_STATUS.SUB_TERMINATED,
      USER_PRODUCT_STATUS.SUB_CANCELLED,
    ].indexOf(status as USER_PRODUCT_STATUS) > -1
  );
};

export const getEndDateToFormat = (endDate: string): string => {
  return dayjs(endDate).diff(dayjs(), "hour") > 48 ? "day" : "hour";
};

export const getTranslateName = (): "koName" | "enName" => {
  return isKorean() ? "koName" : "enName";
};

export const isRemain = (utcString: string): boolean =>
  dayjs(utcString).diff(dayjs(), "day", true) > 0;

export const calcRemainDay = (
  utcString: string,
): {
  isRemain: boolean;
  isShowDate: boolean;
  date: number;
  time: number;
  format: string;
  translateName: string;
  dayjsName: string;
} => {
  // true: 소수점까지 출력
  const remainDay = dayjs(utcString).diff(dayjs(), "day", true);
  const isShowDate = remainDay * 24 > 48; // 48시간 초과 남은 경우
  return {
    isRemain: remainDay > 0,
    isShowDate,
    date: Math.floor(remainDay),
    time: Math.floor(remainDay * 24),
    format: isShowDate ? "YYYY.MM.DD" : "YYYY.MM.DD HH:mm",
    translateName: isShowDate ? "date" : "hour",
    dayjsName: isShowDate ? "day" : "hour",
  };
};

export const editEndDateHour = (
  products: CheckoutUserProduct[],
): CheckoutUserProduct[] => {
  return products.map((product) => {
    if (isSubscription(product.status)) {
      product.endDate = dayjs(product.endDate).add(-12, "hour").utc().format();
    }
    return product;
  });
};

export const getDurationTranslation = (durationType: string): string => {
  if (durationType === "HOUR") return "product/purchase/billing_period_hour";
  else if (durationType === "DAY") return "product/purchase/billing_period_day";
  else if (durationType === "MONTH")
    return "product/purchase/billing_period_month";
  return "";
};

export const getRestartConfirmTranslation = (durationType: string): string => {
  if (durationType === "HOUR")
    return "product/auto-payment/confirm_restart_hour";
  else if (durationType === "DAY")
    return "product/auto-payment/confirm_restart_day";
  else if (durationType === "MONTH")
    return "product/auto-payment/confirm_restart_month";
  return "";
};

export const getRestartSuccessTranslation = (durationType: string): string => {
  if (durationType === "HOUR")
    return "product/auto-payment/success_restart_hour";
  else if (durationType === "DAY")
    return "product/auto-payment/success_restart_day";
  else if (durationType === "MONTH")
    return "product/auto-payment/success_restart_month";
  return "";
};
